import { createUpdateTxsReducer } from './update-txs.js'

export default createUpdateTxsReducer({ addOnly: true })
